import { CSSProperties, PropsWithChildren } from "react";

type CellShadeWrapperProps = {
  outerClassName?: string;
  innerClassName?: string;
  innerStyle?: CSSProperties;
};

export default function CellShadeWrapper({
  children,
  outerClassName,
  innerClassName,
  innerStyle,
}: PropsWithChildren<CellShadeWrapperProps>) {
  return (
    <div
      className={
        "bg-black border-black border active:mt-[1px]" + " " + outerClassName
      }
    >
      <div
        className={
          "border-black border-b-2 border-r-[1px] active:border-b-[1px] active:border-r-0" +
          " " +
          innerClassName
        }
        style={innerStyle}
      >
        {children}
      </div>
    </div>
  );
}
